<template>
  <div class="description">
    <img :src="image" />
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    content: String
  }
};
</script>

<style lang="scss" scoped>
.description {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f6e699;
  border-radius: 100px;
  padding: 12px 50px;

  img {
    width: 250px;
  }

  p {
    flex: 1;
    margin-left: 30px;
    color: black;
    font-size: 18px;
    letter-spacing: 3px;
    line-height: 1.5rem;
  }
}

@media (max-width: 480px) {
  .description {
    padding: 5px 15px !important;
    border-radius: 35px !important;

    img {
      width: 85px !important;
    }

    p {
      font-size: 16px;
    }
  }
}
</style>
